import { useGlobal } from "../context/ContenedorGlobal";
import { useState, useEffect } from "react";
import { useApiFetch } from "../utils/apiFetch";
import "../styles/Formularios.css";
import "../styles/ReportesPorCategoria.css";
import InputGenerico from "./InputGenerico";
import InputSelectGenerico from "./InputSelectGenerico";
import InputSelectAcciones from "./InputSelectAcciones";
import InputSelectTablaAfec from "./InputSelectTablaAfec";
import InputSelectModFijos from "./InputSelectModFijos";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import logo from "../assets/logo_sict.png";

function ConsultarBitacora() {

    const { logout } = useGlobal();
    const apiFetch = useApiFetch();

    const [vista, setVista] = useState("seleccOpciones"); // Estado para controlar qué vista mostrar
    const [filtroPrincipal, setFiltroPrincipal] = useState(null);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [resultados, setResultados] = useState([]);

    const [bitacora, setBitacora] = useState(null);
    const [bitacoraInicial, setBitacoraInicial] = useState(null);
    const [bitacoraFinal, setBitacoraFinal] = useState(null);
    const [idTecnico, setIdTecnico] = useState(null);
    const [fechaInicial, setFechaInicial] = useState(null);
    const [fechaFinal, setFechaFinal] = useState(null);
    const [accion, setAccion] = useState(null);
    const [tablaAfectada, setTablaAfectada] = useState(null);
    const [categoria, setCategoria] = useState(null);
    const [palabra, setPalabra] = useState(null);


    // Estado para checkboxes de filtros //////////////////////////ok
    const filtrosIniciales = {
        opcBitacora: false,
        opcRangoBitacoras: false,
        opcTecnico: false,
        opcRangoFechas: false,
        opcAccion: false,
        opcTablaAfectada: false,
        opcCategoria: false,
        opcPalabra: false,
        opcTodos: false
    };

    const [filtros, setFiltros] = useState(filtrosIniciales); ///////////////////ok

    // Diccionario de etiquetas para mostrar al usuario /////////////////////ok
    const etiquetas = {
        opcBitacora: "Registro",
        opcRangoBitacoras: "Rango de registros",
        opcTecnico: "Técnico",
        opcRangoFechas: "Rango de fechas",
        opcAccion: "Actividad principal",
        opcTablaAfectada: "Tabla afectada",
        opcCategoria: "Categoría",
        opcPalabra: "Palabra clave",
        opcTodos: "Todos los registros"
    };

    // Reglas de habilitación/deshabilitación por cada opcion elegida, para que las consultas tengan sentido ///////////////////ok
    const reglas = {
        opcBitacora: {
            deshabilita: [
                "opcRangoBitacoras", "opcTecnico", "opcRangoFechas", "opcAccion", "opcTablaAfectada", "opcCategoria", "opcPalabra"]
        },
        opcRangoBitacoras: {
            deshabilita: ["opcBitacora", "opcRangoFechas"]
        },
        opcTecnico: {
            deshabilita: ["opcBitacora", "opcRangoBitacoras"]
        },
        opcRangoFechas: {
            deshabilita: ["opcBitacora", "opcRangoBitacoras"]
        },
        opcAccion: {
            deshabilita: ["opcBitacora", "opcRangoBitacoras", "opcPalabra"]
        },
        opcTablaAfectada: {
            deshabilita: ["opcBitacora", "opcRangoBitacoras", "opcPalabra", "opcCategoria"]
        },
        opcCategoria: {
            deshabilita: ["opcBitacora", "opcRangoBitacoras", "opcPalabra"]
        },
        opcPalabra: {
            deshabilita: ["opcBitacora", "opcRangoBitacoras", "opcCategoria", "opcTablaAfectada", "opcAccion"]
        },
        opcTodos: {
            deshabilita: ["opcBitacora", "opcRangoBitacoras", "opcTecnico", "opcRangoFechas", "opcAccion", "opcTablaAfectada", "opcCategoria", "opcPalabra"]
        }
    };

    const handleChange = (campo) => {
        const nuevaConfig = { ...filtros };

        if (filtros[campo]) {
            // Si se desmarca un campo
            nuevaConfig[campo] = false;

            // Si era el filtro principal, se quita y se reestablece todo
            if (filtroPrincipal === campo) {
                setFiltroPrincipal(null);
                // Reinicia todos los filtros a su estado inicial
                Object.keys(nuevaConfig).forEach(opc => {
                    nuevaConfig[opc] = false;
                });
            }

        } else {
            // Activas el campo
            nuevaConfig[campo] = true;

            // Si aún no hay filtro principal, este se convierte en el principal
            if (!filtroPrincipal) {
                setFiltroPrincipal(campo);

                // Se aplican reglas de deshabilitación SOLO del principal
                if (reglas[campo]?.deshabilita) {
                    reglas[campo].deshabilita.forEach(opc => {
                        nuevaConfig[opc] = false;
                    });
                }
            }
            // Si ya existe un filtro principal, no se cambian las reglas
        }

        setFiltros(nuevaConfig);
    };

    // Limpiar los inpus para facilitar el reingreso de datos   /////////////////////////////////////ok
    const handleLimpiar = () => {
        setBitacora("");
        setBitacoraInicial("");
        setBitacoraFinal("");
        setIdTecnico(null);
        setFechaInicial("");
        setFechaFinal("");
        setAccion(null);
        setTablaAfectada(null);
        setCategoria(null);
        setPalabra("");

        setResultados([]);
        setSuccess("");
        setError("");
    };

    // Funcion para limpiar los mensajes   ////////////////////////////////////////////ok
    useEffect(() => {
        if (success || error) {
            const timer = setTimeout(() => {
                setSuccess("");
                setError("");
            }, 3000);

            return () => clearTimeout(timer); // Limpia el timer si cambia el estado
        }
    }, [success, error]);


    // Función para realizar validaciones de filtros seleccionados y los valores de sus variables  /////////////////////////////ok
    function validarCampos(filtros, {
        bitacora,
        bitacoraInicial,
        bitacoraFinal,
        idTecnico,
        fechaInicial,
        fechaFinal,
        accion,
        tablaAfectada,
        categoria,
        palabra
    }) {
        // Todas las bitácoras
        if (filtros.opcTodos) {
            return { valido: true, mensaje: "" };
        }

        // Bitacora única
        if (filtros.opcBitacora && !bitacora) {
            return { valido: false, mensaje: "Debes ingresar el número de registro." };
        }

        // Rango de bitacoras
        if (filtros.opcRangoBitacoras) {
            if (!bitacoraInicial || !bitacoraFinal) {
                return { valido: false, mensaje: "Debes ingresar ambos registros." };
            }
            if (parseInt(bitacoraFinal) <= parseInt(bitacoraInicial)) {
                return { valido: false, mensaje: "El registro final debe ser mayor al inicial." };
            }
        }

        // Técnico
        if (filtros.opcTecnico && !idTecnico) {
            return { valido: false, mensaje: "Debes seleccionar un técnico." };
        }

        // Rango de fechas
        if (filtros.opcRangoFechas) {
            if (!fechaInicial || !fechaFinal) {
                return { valido: false, mensaje: "Debes ingresar ambas fechas." };
            }
            if (new Date(fechaFinal) <= new Date(fechaInicial)) {
                return { valido: false, mensaje: "La fecha final debe ser mayor a la inicial." };
            }
        }

        // Acción
        if (filtros.opcAccion && !accion) {
            return { valido: false, mensaje: "Debes seleccionar un tipo de acción." };
        }

        // Tabla afectada
        if (filtros.opcTablaAfectada && !tablaAfectada) {
            return { valido: false, mensaje: "Debes seleccionar una tabla." };
        }

        // Categoria o módulo
        if (filtros.opcCategoria && !categoria) {
            return { valido: false, mensaje: "Debes seleccionar una categoría o módulo." };
        }

        // Palabra
        if (filtros.opcPalabra && !palabra) {
            return { valido: false, mensaje: "Debes ingresar una palabra clave." };
        }

        // Si pasa todas las validaciones
        return { valido: true, mensaje: "" };
    }


    // Diccionario de cabeceras para la lista que se muestra al usuario y sea mas entendible   //////////////////////////ok
    const diccionarioCabeceras = {
        id_bitacora: "Registro",
        id_tecnico: "No. empleado",
        fecha_hora: "Fecha",
        accion: "Acción",
        descripcion_detallada: "Información complementaria",
        tabla_afectada: "Tabla afectada",
        id_registro_afectado: "Id del registro afectado",
        ip_origen: "Ip origen",
        user_agent: "User Agent",
        modulo: "Categoría"
    };

    // Función para mostrar solo ciertas columnas y no saturar la pantalla con exceso de información //////////////ok
    const columnasVisibles = [
        "id_bitacora",
        "id_tecnico",
        "fecha_hora",
        "accion"
    ];

    // Función para conectar y enviar los datos a la api
    const handleGenerarReporte = async () => {
        const valores = {
            bitacora,
            bitacoraInicial,
            bitacoraFinal,
            idTecnico,
            fechaInicial,
            fechaFinal,
            accion,
            tablaAfectada,
            categoria,
            palabra,

            filtroPrincipal
        };

        const resultado = validarCampos(filtros, valores);

        if (!resultado.valido) {
            setError(resultado.mensaje);
            setSuccess("");
            return;
        }

        try {
            const data = await apiFetch("bitacora.php", {
                method: "POST",
                body: JSON.stringify(valores),
                headers: { "Content-Type": "application/json" }
            }, logout);

            if (data.status === "ok" && data.data.length > 0) {
                setResultados(data.data || []); // Se guardan los resultados
                setSuccess("Reporte generado correctamente.");
                setVista("resultados");
                setError("");
            } else if (data.status === "no_results") {
                setError("No se encontraron registros que cumplan con los filtros.");
                setSuccess("");
            } else {
                setError("Error al generar reporte: " + (data.message || "Error desconocido."));
                setSuccess("");
            }
        } catch (err) {
            setError("Error de conexión: " + err.message);
            setSuccess("");
        }
    };

    // Funcion para exportar en CSV (todas las columnas de la consulta)
    const exportCSV = () => {
        if (!resultados.length) return;

        const columnas = Object.keys(resultados[0]); // Todas las columnas no solo las visibles en PDF
        const filas = resultados.map(fila =>
            columnas.map(col => {
                let valor = fila[col] !== null ? String(fila[col]) : "";
                // Escapar comillas dobles
                valor = valor.replace(/"/g, '""');
                // Encapsular en comillas si contiene coma, salto de línea o comillas para mantener dato y encabezado correctos
                if (/[",\n]/.test(valor)) {
                    valor = `"${valor}"`;
                }
                return valor;
            })
        );

        const csvRows = [];
        csvRows.push(columnas.join(",")); // Encabezados
        filas.forEach(row => csvRows.push(row.join(",")));

        const csvString = csvRows.join("\n");
        const BOM = "\uFEFF"; // UTF-8 BOM
        const blob = new Blob([BOM + csvString], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "reporte_bitacora.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };


    // Función para exportar en PDF (solo lo que se muestra en la tabla)
    const exportPDF = () => {
        if (!resultados.length) return;

        const doc = new jsPDF();

        // Logo institucional
        doc.addImage(logo, "PNG", 10, 10, 30, 15);

        // Encabezado
        doc.setFontSize(14);
        doc.text("Secretaría de Infraestructura, Comunicaciones y Transportes", 50, 20);
        doc.setFontSize(12);
        doc.text("Reporte de Bitácora", 50, 30);

        doc.setLineWidth(0.5);
        doc.line(10, 40, 200, 40);

        // Tabla con columnas visibles
        autoTable(doc, {
            startY: 50,
            head: [columnasVisibles.map(col => diccionarioCabeceras[col] || col)],
            body: resultados.map(fila =>
                columnasVisibles.map(col => fila[col])
            )
        });

        // Pie de página
        doc.setFontSize(10);
        doc.text("© 2026 SIGBI-712. Todos los derechos reservados.", 10, 290);

        doc.save("reporte_bitacora.pdf");
    };

    // Función para regresar de la vista formulario a la vista de seleccion de opciones de filtrado   ////////////////////////////ok
    const handleRegresar = () => {
        handleLimpiar();
        setFiltros(filtrosIniciales);
        setFiltroPrincipal(null);
        setSuccess("");
        setError("");
        setVista("seleccOpciones");
    };

    // Función para regresar al formulario en caso de aplicar
    const handleRegresarFormulario = () => {
        setSuccess("");
        setError("");
        setResultados([]);

        if (filtros.opcTodos) {
            // Caso especial: no aplica formulario
            setVista("seleccOpciones");
        } else {
            // Flujo normal
            setVista("formulario");
        }
    };

    return (
        <div className="sesion-form">
            {vista === "seleccOpciones" && (
                <div>
                    {error && <div className="error">{error}</div>}

                    <div className="filtros-container">
                        {Object.keys(filtros).map((campo) => {
                            const deshabilitado = filtroPrincipal
                                ? reglas[filtroPrincipal]?.deshabilita?.includes(campo)
                                : false;

                            return (
                                <label
                                    key={campo}
                                    className={deshabilitado ? "checkbox-disabled" : "checkbox-enabled"}
                                >
                                    <input
                                        type="checkbox"
                                        checked={filtros[campo]}
                                        onChange={() => handleChange(campo)}
                                        disabled={deshabilitado}
                                    />
                                    {etiquetas[campo]}
                                </label>
                            );
                        })}
                    </div>

                    <div className="form-buttons">
                        <button onClick={() => {
                            setFiltros(filtrosIniciales);
                            setFiltroPrincipal(null);
                        }}>
                            Limpiar
                        </button>
                        <button
                            onClick={() => {
                                // Si el filtro principal es "opcTodos"
                                if (filtros.opcTodos) {
                                    setError(""); // limpia error
                                    // Ejecuta directamente la función que conecta con la API
                                    handleGenerarReporte();
                                    return; // evita seguir con la lógica normal
                                }

                                const algunFiltroActivo = Object.values(filtros).some(v => v === true);

                                if (!algunFiltroActivo) {
                                    setError("Debes seleccionar al menos un filtro antes de continuar.");
                                    return;
                                }

                                setError(""); // Limpia el error si todo está bien
                                setVista("formulario");
                            }}
                        >
                            Continuar
                        </button>
                    </div>
                </div>
            )}

            {vista === "formulario" && (
                <div>
                    {error && <div className="error">{error}</div>}

                    <h3>Ingrese los datos para generar el reporte</h3>

                    {filtros.opcBitacora && (
                        <div>
                            <InputGenerico
                                value={bitacora}
                                setValue={setBitacora}
                                label="Ingrese el número de registro"
                                maxLength={5}
                                allowedChars="0-9"
                                placeholder="123"
                                title="Ingrese solo dígitos"
                            />
                        </div>
                    )}

                    {filtros.opcRangoBitacoras && (
                        <div>
                            <InputGenerico
                                value={bitacoraInicial}
                                setValue={setBitacoraInicial}
                                label="Ingrese el registro inicial"
                                maxLength={5}
                                allowedChars="0-9"
                                placeholder="123"
                                title="Ingrese solo dígitos"
                            />

                            <InputGenerico
                                value={bitacoraFinal}
                                setValue={setBitacoraFinal}
                                label="Ingrese el registro final"
                                maxLength={5}
                                allowedChars="0-9"
                                placeholder="123"
                                title="Ingrese solo dígitos"
                            />
                        </div>
                    )}

                    {filtros.opcTecnico && (
                        <div>
                            <InputSelectGenerico
                                idSeleccionado={idTecnico}
                                setIdSeleccionado={setIdTecnico}
                                label="Seleccione un Técnico"
                                apiUrl={`consultar_tecnicos2.php`}
                                valueField="id_tecnico"
                                displayField={(o) => o.nombre_completo}
                                readOnly={false}
                                showDefaultOption={true}
                                defaultOptionText="Seleccione un técnico"
                                dataField="tecnicos"
                            />
                        </div>
                    )}

                    {filtros.opcRangoFechas && (
                        <div>
                            <label>Fecha inicial:</label>
                            <input
                                type="date"
                                value={fechaInicial}
                                onChange={(e) => setFechaInicial(e.target.value)}
                            />

                            <label>Fecha final:</label>
                            <input
                                type="date"
                                value={fechaFinal}
                                onChange={(e) => setFechaFinal(e.target.value)}
                            />
                        </div>
                    )}

                    {filtros.opcAccion && (
                        <div>
                            <InputSelectAcciones
                                value={accion}
                                setValue={setAccion}
                                label="Seleccione una acción"
                            />
                        </div>
                    )}

                    {filtros.opcTablaAfectada && (
                        <div>
                            <InputSelectTablaAfec
                                value={tablaAfectada}
                                setValue={setTablaAfectada}
                                label="Seleccione una tabla"
                            />
                        </div>
                    )}

                    {filtros.opcCategoria && (
                        <div>
                            <InputSelectModFijos
                                value={categoria}
                                setValue={setCategoria}
                                label="Seleccione la categoría"
                            />
                        </div>
                    )}

                    {filtros.opcPalabra && (
                        <div>
                            <InputGenerico
                                value={palabra}
                                setValue={setPalabra}
                                label="Ingrese palabra clave"
                                maxLength={30}
                                allowedChars="a-zA-Z0-9ÁÉÍÓÚáéíóúñÑ "
                                placeholder="quemado"
                                title="Ingrese solo letras, números y espacios"
                            />
                        </div>
                    )}

                    <div className="form-buttons">
                        <button onClick={handleGenerarReporte}>
                            Generar<br />reporte
                        </button>
                        <button onClick={handleLimpiar}>
                            Limpiar<br />datos
                        </button>
                        <button onClick={handleRegresar}>
                            Regresar
                        </button>

                    </div>

                </div>
            )}

            {vista === "resultados" && (
                <div>
                    <h3>Resultados de la bitacora</h3>

                    {resultados.length > 0 && (
                        <>
                            <table className="tabla-estandar">
                                <thead>
                                    <tr>
                                        {columnasVisibles.map((col) => (
                                            <th key={col}>{diccionarioCabeceras[col] || col}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {resultados.map((fila, idx) => (
                                        <tr key={idx}>
                                            {columnasVisibles.map((col) => (
                                                <td key={col} data-label={diccionarioCabeceras[col] || col}>
                                                    {fila[col]}
                                                </td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <div className="form-buttons">
                                <button onClick={handleRegresarFormulario}>Regresar</button>
                                <button onClick={exportCSV}>Exportar<br></br>en CSV</button>
                                <button onClick={exportPDF}>Exportar<br></br>en PDF</button>
                            </div>
                        </>
                    )}

                </div>
            )}

        </div>
    );
}

export default ConsultarBitacora;